module.exports = __webpack_public_path__ + "assets/img/3661-re.svg";